/*
 * @Author: Tarzan
 * @Date: 2021-02-01 15:47:44
 * @LastEditTime: 2022-01-11 16:41:39
 * @LastEditors: Please set LastEditors
 * @Description: 公用
 * @FilePath: \mall_pc\src\fix.js
 */
import store from '@/store'

let getPrice = function (val) {
	const code = store.getters.code
	let nowPrice = 0
  	if (val.activityType === 8) { // 活动商品 1.一口价，3.秒杀，7.预售，8.集采，9.低价购
  		nowPrice = val.stepPriceList[val.stepPriceList.length - 1].price
  	} else if (val.activityPrice > 0 && val.activityType !== 7) { // 有活动价//预售没有活动价
  		nowPrice = val.activityPrice
  	} else if (val.isConsumables == 1 && code && val.memberPrice) { //易耗品//并且是会员价//code会员卡号
  		nowPrice = val.memberPrice
  	} else if (val.currDisCount > 0) { // 护肤品有折扣价
  		nowPrice = val.currDisCountPrice
  	} else {
  	  nowPrice = val.skuPrice
  	}
  	return nowPrice
}

const fix = {}
fix.install = function(Vue, options) {
	Vue.prototype.toFixedTwo = function(value) { //保留两位小数
		if(value == undefined) {
			value = '-';
			return value
		} else if(value == null) {
			value = '-';
			return value
		} else {
			var v = value * 100 / 100
			return v.toFixed(2);
		}
	};

	Vue.prototype.$getListText = function (list, val) {
		let row = list.find((c) => c.value === val)
		if (row) {
			return row.label;
		} else {
			return "--";
		}
	}

	Vue.prototype.getNowPrice = getPrice

	Vue.prototype.getOriginPrice = function(val) { // 计算金额
		const code = store.getters.code
		var oldPirce = val.skuPrice
		var nowPrice = getPrice(val)
		if (nowPrice < oldPirce) {
			return oldPirce
		} else {
			return ''
		}
	};

	/**
	 * 组合函数
	 * @param {Array<Function>} args
	 * @description: 从右往左执行
	 */
	Vue.prototype.$componse = function componse(...args) {
		return function (value) {
			return args.reverse().reduce((acc, fn) => fn(acc), value)
		}
	}

	Vue.prototype.$parseTag = function(tag) {
		// 解析标签
		if (!tag || typeof tag != 'string') {
			return []
		}
		if (!tag.trim()) {
			return []
		}
		return tag.split(',')
	}
};

export default fix
